import DeletePropertyContainer from "./DeletePropertyContainer";
export default DeletePropertyContainer;
